import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Common/Modal/Modal';
import Toggle from '../../Common/Toggle/Toggle';
import Moment from 'moment';
import { DATE_FORMAT } from '../../../constants/constants';

class ChangeStartDateModal extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            keepTargetDate: true
        }
    }


    toggleKeepTargetDate = () => {
        this.setState({ keepTargetDate: !this.state.keepTargetDate });
    }

    onPrimaryClick = () => {
        const startTo = Moment.utc(this.props.task.startDate).add(this.props.deltaDays, 'days').format(DATE_FORMAT);
        const currentTargetDate = Moment.utc(this.props.task.targetDate).format(DATE_FORMAT);
        const modifiedTargetDate = Moment.utc(this.props.task.targetDate).add(this.props.deltaDays, 'days').format(DATE_FORMAT);
        const chosenTargetDate = (this.state.keepTargetDate) ? currentTargetDate : modifiedTargetDate;
        this.props.onComplete(startTo, chosenTargetDate);
    }

    renderBody = () => {
        const startFrom = Moment.utc(this.props.task.startDate).format(DATE_FORMAT);
        const startTo = Moment.utc(this.props.task.startDate).add(this.props.deltaDays, 'days').format(DATE_FORMAT);

        const currentTargetDate = Moment.utc(this.props.task.targetDate).format(DATE_FORMAT);
        const modifiedTargetDate = Moment.utc(this.props.task.targetDate).add(this.props.deltaDays, 'days').format(DATE_FORMAT);

        // dragging and dropping will change both the start and target dates
        // However, if the user doesn't have access to chnage the target date, then it will stay the same
        // If they do, then we present them with the option of keeping the current target date
        if(this.props.userCanChangeTargetDate){
            return (
                <div className="text-left">
                    <div>Dragging and dropping this event changes both the Start Date AND the Target Date.</div><br />
                    <div>You will be changing the Start Date from {startFrom} to {startTo}?</div>
                    <br />
                    <br />
                    <div className="col-8"><Toggle name="keepTargetDate" text="Keep the target date the same" checked={this.state.keepTargetDate} onChange={this.toggleKeepTargetDate} /></div>
                    <br />
                    <div>Target Date will be: {(this.state.keepTargetDate) ? currentTargetDate : modifiedTargetDate }</div>
                </div>
            )            
        } else {
            return (
                <div>Are you sure you want to change the Start Date from {startFrom} to {startTo}?</div>
            )
        }

    }

    render() {
        return (
            <Modal
                id="changeStartDateModal"
                title="Confirm Change"
                body={this.renderBody()}
                onCloseClick={this.props.onCancel}
                onPrimaryClick={this.onPrimaryClick}
                onSecondaryClick={this.props.onCancel}
            />   
        )        
    }
}

ChangeStartDateModal.propTypes = {
    task: PropTypes.object.isRequired,
    deltaDays: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    userCanChangeTargetDate: PropTypes.bool.isRequired
};

export default ChangeStartDateModal;
